// Helper for deep comparison of simple objects via JSON serialization
export const jsonDeepEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);
